import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell from "../components/Auth/AuthShell";
import { PATHS } from "../routes/paths";
import api from "../services/api";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      await api.post("/auth/login", { email, password });
      navigate(PATHS.adminHome, { replace: true });
    } catch (requestError) {
      if (!requestError.response) {
        setError("Não foi possível conectar ao servidor.");
      } else if (requestError.response.status === 401) {
        setError("E-mail ou senha inválidos.");
      } else {
        setError("Não foi possível entrar. Tente novamente.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthShell title="Login">
      <form className="auth-form" onSubmit={handleSubmit}>
        <label className="auth-form__field">
          <span className="auth-form__label">E-mail</span>
          <input
            className="auth-form__input"
            type="email"
            placeholder="E-mail"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            autoComplete="email"
            required
          />
        </label>

        <div className="auth-form__field">
          <label className="auth-form__label" htmlFor="login-password">
            Senha
          </label>
          <div className="auth-form__password-input">
            <input
              id="login-password"
              className="auth-form__input"
              type={showPassword ? "text" : "password"}
              placeholder="Senha"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className="auth-form__password-toggle"
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => setShowPassword((visible) => !visible)}
              aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
              aria-pressed={showPassword}
            >
              {showPassword ? (
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M2.2 10.1a1.8 1.8 0 0 0 0 1.8C3.2 13.5 6.8 18 12 18s8.8-4.5 9.8-6.1a1.8 1.8 0 0 0 0-1.8C20.8 8.5 17.2 4 12 4S3.2 8.5 2.2 10.1Z" />
                  <circle cx="12" cy="11" r="3" />
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M3 3l18 18" />
                  <path d="M10.6 10.6a2 2 0 0 0 2.8 2.8" />
                  <path d="M9.9 4.2A10.8 10.8 0 0 1 12 4c5.2 0 8.8 4.5 9.8 6.1a1.8 1.8 0 0 1 0 1.8 14 14 0 0 1-3 3.6" />
                  <path d="M6.2 6.2A14.1 14.1 0 0 0 2.2 10a1.8 1.8 0 0 0 0 1.8C3.2 13.5 6.8 18 12 18c1.1 0 2.1-.2 3-.6" />
                </svg>
              )}
            </button>
          </div>
        </div>

        <Link className="auth-form__link" to={PATHS.forgotPassword}>
          Esqueci minha senha
        </Link>

        {error && <p className="auth-form__message auth-form__message--error">{error}</p>}

        <button className="auth-form__button" type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </AuthShell>
  );
};

export default Login;
